import React from 'react';
import { connect } from 'react-redux';
import { requestServiceLocationDetails } from '../../../store/service-location-manager/ServiceLocationManagerActions';

class ServiceLocationDetails extends React.Component {
  
  componentWillMount() {
    this.props.getServiceLocation(this.props.serviceLocationId, {
      tenantId: this.props.tenantId,
    });
  }

  render() {
    const {
      data: { serviceLocation }
    } = this.props;
    var state = serviceLocation.state && serviceLocation.state.code;

    return (
      <div >
        {serviceLocation.id && (
          <panel className="form-control" style={{ height: '110px' }} disabled>
            <span>{serviceLocation.serviceProvider}</span>
            <br />
            <span>{serviceLocation.address1} {serviceLocation.address2}</span>
            <br />
            <span>{serviceLocation.city} {state} {serviceLocation.zipCode}</span>
            <br />
            <span>{serviceLocation.phone}</span>
            <br />
            <span>{serviceLocation.email}</span>
          </panel>
         )}
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.servicelocationmanager,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getServiceLocation: (id, params) => dispatch(requestServiceLocationDetails(id, params)),
  }),
)(ServiceLocationDetails);



// WEBPACK FOOTER //
// ./src/routes/service-request-manager/components/ServiceLocationDetails.js